export default "__VITE_ASSET__5$LzZ9S$__"